/**
 * Shared factory for CRM filter condition catalogs.
 * Returns FooFilters() → { allConditionTypes, conditionByName, conditions }
 * with the same shape callers already use.
 */
export default function createConditionCatalog(allConditionTypes) {
  const data = {
    allConditionTypes,
    conditionByName(name) {
      return data.allConditionTypes.find((x) => x.name === name);
    },
    conditions() {
      return data.allConditionTypes;
    },
  };
  return function () {
    return data;
  };
}
